import { Component, createSignal } from "solid-js";
import Arrow from "../assets/icons/arrowDown.svg";
import Styles from "bundle-text:../styles/_defaultAcordeon.scss";

interface DefaultAcordeonProps {
  title: string;
  children: any;
  isOpen?: boolean;
}

const DefaultAcordeon: Component<DefaultAcordeonProps> = (props) => {
  const [isOpen, setIsOpen] = createSignal(props.isOpen || false);
  const toggleOpen = () => {
    setIsOpen(!isOpen());
  };

  return (
    <>
      <style>{Styles}</style>
      <div class="default-acordeon">
        <div class="header" classList={{ open: isOpen() }} onClick={toggleOpen}>
          <h3>
            {props.title}
            <span>*</span>
          </h3>
          <img src={Arrow} alt="Toggle Acordeon" />
        </div>
        {isOpen() && <div class="body">{props.children}</div>}
      </div>
    </>
  );
};
export default DefaultAcordeon;
